module.exports = __webpack_public_path__ + "static/media/css3.701270ac.png";